<template>
  <el-dialog
    title="Toplu Fatura Yazdır"
    :visible="Modal"
    center
    width="30%">
    <a @click="$emit('Modal', false)" class="ModalKapat yazdirma"><i class="el-icon-close"></i></a>
    <h5 class="yazdirma text-center" style="margin: 0">
      {{ TopluData.length }} adet fatura oluşturuldu
    </h5>
    <div class="yazdirtable " v-for="Data in TopluData">

      <div class="faturayazdir row">
        <div :class="YazdirTur==2?'col-6':'col-12'">
          <table style="border: none !important;" class="table-nohover table tablebordered table-xs ">
            <tbody>
            <tr>
              <td class="text-right">
                <small class="d-block">FATURA TARİHİ</small>
                {{ Data.Tarih }}
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table-nohover table tablebordered table-xs ">
            <tbody>
            <tr>
              <td>
                <small class="d-block">ÜNVAN</small>
                {{ Data.BinaBilgi.Adi }}
              </td>
              <td>
                <small class="d-block">VERGİ DAİRESİ</small>
                {{ Data.BinaBilgi.vDairesi }}
              </td>
              <td>
                <small class="d-block">VERGİ NO</small>
                {{ Data.BinaBilgi.vNo }}
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <small class="d-block">ADRES</small>
                {{ Data.BinaBilgi.Adres }}
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table-nohover table tablebordered table-xs ">
            <thead>
            <tr>
              <th>AÇIKLAMA</th>
              <th class="text-center">ADET</th>
              <th class="text-right">FİYAT</th>
              <th class="text-right">TUTAR</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ Data.Aciklama }}</td>
              <td class="text-center">1</td>
              <td class="text-right">{{ Data.Kdvsiz }}</td>
              <td class="text-right">{{ Data.Kdvsiz }}</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="3" class="text-right">TOPLAM</th>
              <th class="text-right">{{ Data.Kdvsiz }}</th>
            </tr>
            <tr>
              <th colspan="3" class="text-right">K.D.V. (%18)</th>
              <th class="text-right">{{ Data.Kdv }}</th>
            </tr>
            <tr>
              <th colspan="3" class="text-right">GENEL TOPLAM</th>
              <th class="text-right">{{ Data.Tutar }}</th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="col-6" v-if="YazdirTur==2">
          <table style="border: none !important;" class="table-nohover table tablebordered table-xs ">
            <tbody>
            <tr>
              <td class="text-right">
                <small class="d-block">FATURA TARİHİ</small>
                {{ Data.Tarih }}
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table-nohover table tablebordered table-xs ">
            <tbody>
            <tr>
              <td>
                <small class="d-block">ÜNVAN</small>
                {{ Data.BinaBilgi.Adi }}
              </td>
              <td>
                <small class="d-block">VERGİ DAİRESİ</small>
                {{ Data.BinaBilgi.vDairesi }}
              </td>
              <td>
                <small class="d-block">VERGİ NO</small>
                {{ Data.BinaBilgi.vNo }}
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <small class="d-block">ADRES</small>
                {{ Data.BinaBilgi.Adres }}
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table-nohover table tablebordered table-xs ">
            <thead>
            <tr>
              <th>AÇIKLAMA</th>
              <th class="text-center">ADET</th>
              <th class="text-right">FİYAT</th>
              <th class="text-right">TUTAR</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ Data.Aciklama }}</td>
              <td class="text-center">1</td>
              <td class="text-right">{{ Data.Kdvsiz }}</td>
              <td class="text-right">{{ Data.Kdvsiz }}</td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th colspan="3" class="text-right">TOPLAM</th>
              <th class="text-right">{{ Data.Kdvsiz }}</th>
            </tr>
            <tr>
              <th colspan="3" class="text-right">K.D.V. (%18)</th>
              <th class="text-right">{{ Data.Kdv }}</th>
            </tr>
            <tr>
              <th colspan="3" class="text-right">GENEL TOPLAM</th>
              <th class="text-right">{{ Data.Tutar }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
      <div class="sayfasonu"></div>

    </div>
    <div slot="footer" class="dialog-footer text-center yazdirma">
      <el-button-group>
        <el-button type="primary" @click="Print(1)" size="small" icon="el-icon-s-management">
          Yazdır
        </el-button>
        <el-button type="success" @click="Print(2)" size="small" icon="el-icon-s-ticket">
          Çift Yazdır
        </el-button>
      </el-button-group>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['Modal', 'TopluData'],
  data() {
    return {
      YazdirTur: 1
    }
  },
  methods: {
    Print(Tur) {
      this.YazdirTur = Tur;
      setTimeout(() => {
        window.print();
      }, 100);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/Comp/TopluFaturaYazdir.vue